import { render } from "./Wallet.vue?vue&type=template&id=69d23b70&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"

import "./Wallet.vue?vue&type=style&index=0&id=69d23b70&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d23b70"]])

export default __exports__